import React, { useState, forwardRef, useImperativeHandle } from "react";
import {
    Box,
    Button,
    Paper,
    Typography,
    MobileStepper,
    Container,
} from "@mui/material";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";

const ChangeShiftStepperPlus = forwardRef((props, ref) => {
    const [activeStep, setActiveStep] = useState(0);
    const [isSent, setIsSent] = useState(false);
    const steps = [
        {
            label: "1. Seleziona il tuo turno ",
            description: `Clicca su un tuo turno futuro. Una volta evidenziato in verde, potrai procedere al passaggio successivo.`,
        },
        {
            label: props.toUser?.nameSurname
            ? `2. Destinatario: ${props.toUser?.nameSurname}`
            : `2. Scegli il destinatario`,
            description: `Cambia con il turno di un collega o scegli a chi cederlo (icona). La scelta è consentita solo se entrambi possedete i ruoli compatibili`,
        },
        {
            label: `3. Conferma e invia`,
            description: `Invia la richiesta a ${props.toUser?.nameSurname}, diventerà effettiva solo dopo la sua approvazione. Se hai inviato più richieste per lo stesso turno, la prima accettata annullerà automaticamente tutte le altre.`,
        },
    ];

    useImperativeHandle(ref, () => ({
        reset() {
            setActiveStep(0);
            setIsSent(false);
            //props.resetStep();
        },
    }));

    const onNext = async () => {
        if (activeStep === steps.length - 1) {
            //props.finalStep();
            const success = await props.handleConfirmation();
            if (success) {
                setIsSent(true); // Passa alla visualizzazione finale
            }
        } else {
            setActiveStep((prev) => prev + 1);
            props.nextStep();
        }
    };

    const onBack = () => {
        setActiveStep((prev) => prev - 1);
        props.prevStep();
    };

    // Validazione dei pulsanti basata sulle props del padre
    const isStepDisabled = () => {
        if (activeStep === 0 && !props.fromUser) return true;
        if (activeStep === 1 && !props.toUser) return true;
        return false;
    };

    return (
        <Box
            sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                minHeight: "15vh",
                
            }}
        >


            {/* AREA CONTROLLI FISSA IN BASSO (Stepper professionale) */}
            <Paper
                elevation={8}
                sx={{
                    position: "fixed",
                    bottom: 86,
                    left: 0,
                    right: 0,
                    zIndex: 90, // Sopra tutto
                    bgcolor: "background.paper",
                    borderTop: "1px solid #e0e0e0",
                    pt: 2,
                    pb: 1,
                }}
            >
                {isSent == true ? (
                    <Container maxWidth="sm">
                        <Typography variant="h6" fontWeight="bold" gutterBottom>
                            ✔️ Richiesta inviata!
                        </Typography>

                        <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
                            La modifica del turno è stata inviata correttamente.
                        </Typography>
                        <Button
                            variant="contained"
                            onClick={() => {
                                setIsSent(false);
                                setActiveStep(1); // Torna alla scelta destinatario
                                props.onPartialReset();
                            }}
                            sx={{ mr: 2 }}
                        >
                            Nuovo Destinatario
                        </Button>
                        <Button
                            variant="contained"
                            onClick={() => {
                                props.onFullReset(); // Chiude e resetta
                            }}>
                            Chiudi
                        </Button>
                    </Container>

                )
                
               : (
                    <Container maxWidth="md">
                        {/* Descrizione dello step */}
                        <Typography
                            variant="subtitle2"
                            fontWeight="bold"
                            color="textPrimary"
                            align="center"
                            gutterBottom
                        >
                            {steps[activeStep].label.toUpperCase()}
                        </Typography>
                        <Typography
                            variant="caption"
                            color="textSecondary"
                            display="block"
                            align="center"
                            sx={{ mb: 2, px: 2 }}
                        >
                            {steps[activeStep].description}
                        </Typography>

                        {/* Mobile Stepper MUI con Progress Bar */}
                        <MobileStepper
                            variant="progress"
                            steps={steps.length}
                            position="static"
                            activeStep={activeStep}
                            sx={{ flexGrow: 1, bgcolor: "transparent", p: 0 }}
                            nextButton={
                                <Button
                                    size="small"
                                    onClick={onNext}
                                    disabled={isStepDisabled()}
                                    variant="contained"
                                >
                                    {activeStep === steps.length - 1 ? "Conferma" : "Avanti"}
                                    <KeyboardArrowRight />
                                </Button>
                            }
                            backButton={
                                <Button
                                    size="small"
                                    onClick={onBack}
                                    disabled={activeStep === 0}
                                >
                                    <KeyboardArrowLeft /> Indietro
                                </Button>
                            }
                        />
                    </Container>
               )
            }
            </Paper>
        </Box>
    );
});

export default ChangeShiftStepperPlus;